import createCachedSelector from 're-reselect';

import { ReduxState } from 'app/redux/types';

import { BettingEntitiesSelectors } from 'app/lib/betting/betting-entities';

export default (tournaments: BettingEntitiesSelectors['tournaments']) => {
  return createCachedSelector(
    (_state: ReduxState, tournamentId: number) => tournamentId,
    tournaments,
    (tournamentId, tournaments) => {
      const tournament = tournaments.get(tournamentId);

      if (tournament && tournament.name) {
        return [tournament.name];
      }
    },
  )((_, tournamentId) => tournamentId);
};
